const formSubmitBtn = document.querySelector<HTMLButtonElement>(
  '.js-prevent-double-form-submit-btn',
);
const form = document.querySelector<HTMLFormElement>(
  '.js-prevent-double-form-submit',
);

// Prevent double submission
form?.addEventListener('submit', () => {
  if (formSubmitBtn && form.checkValidity()) {
    formSubmitBtn.disabled = true;
    if (formSubmitBtn.textContent != '') {
      formSubmitBtn.textContent = 'Processing...';
    } else {
      formSubmitBtn.value = 'Processing...';
    }
  }
});
